<template>
    <div class="employee-show">
      <Header ></Header>
      <Details :employeeDetails="trainerDetails"></Details>
    <b-container v-if="trainerDetails.certificates && trainerDetails.certificates.length > 0" >
      <b-row>
          <b-col md="12" cols="12" >
            <div class="row" >
              <div class="sec-wrapper d-flex align-items-center mb-4">
                <h2 id="famous-companies " class="section-title">الشهادات</h2>
                <div class="blue-line"></div>
              </div>
              <b-row >
                <div
                  v-for="program in trainerDetails.certificates"
                  :key="program.id"
                  class="col-md-3 col-12 mb-30"
                >
                  <ImageView
                    :imageFile="program.file.url"
                  />
                  <div class="d-flex justify-content-center align-items-center py-3">
                  <p >{{ program.name }}</p>
                </div>
                </div>
                
              </b-row>

            </div>
          </b-col>
        </b-row>
    </b-container>
      
      
      <Footer></Footer>
    </div>
  </template>

  <script>
  import Details from '@/components/Employee/Details.vue';
  import Header from '@/components/Employee/Header.vue';
  import Footer from '@/components/Home/Footer.vue';
  import ImageView from "@/components/common/ImageView.vue";
  import axios from 'axios';

  export default {
    name: 'TrainerShow',
    components: { Header, Details , Footer,ImageView },
    data() {
      return {
        trainerDetails: null,
      };
    },
    created() {
      this.fetchTrainerDetails();
    },
    methods: {
      async fetchTrainerDetails() {
        try {
          const response = await axios.get(`ministries/trainers/${this.$route.params.id}`);
          this.trainerDetails = response.data.data.trainer;
          console.log(this.trainerDetails.certificates)
        } catch (error) {
          console.error('Error fetching trainer details:', error);
        }
      },
    },
  };
  </script>

  <style lang="">
  </style>
